const handlePrint = () => {
  window.print();
};

export default handlePrint;
